import { useEffect, useState } from 'react';
import { ModalHeader } from './ModalHeader';
import { Box, styled } from '@mui/material';
import { Typography } from '@chargeafter/ui';

import { CountdownClock } from '../components/CountDownClock';
import { useIdleTimerContext } from 'react-idle-timer';
import { TrackerButton } from '../components/TrackerButtonWrapper';
import { ButtonName } from '../constants';

const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(5),
  alignItems: 'center',
  padding: theme.spacing(5, 3),
}));

enum IDLE_TIME_MODAL_TEXTS {
  TITLE = 'still there?',
  DESC = "We've noticed a period of inactivity. To secure your data, the session will close in 5 minutes.",
  BUTTON_TEXT = "I'm Here",
}

export const IDLE_TIME_MODAL_DURATION_IN_MINUTES = 5;

export const IdleTimeModal = () => {
  const { getRemainingTime, activate } = useIdleTimerContext();
  const [residualTimeInSeconds, setResidualTimeInSeconds] = useState(
    Math.ceil(getRemainingTime() / 1000),
  );

  useEffect(() => {
    const intervalId = setInterval(() => {
      setResidualTimeInSeconds(Math.ceil(getRemainingTime() / 1000));
    }, 500);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return (
    <>
      <ModalHeader title={IDLE_TIME_MODAL_TEXTS.TITLE} />
      <Container>
        <Typography variant="h5">{IDLE_TIME_MODAL_TEXTS.DESC}</Typography>
        <CountdownClock countdownInSeconds={residualTimeInSeconds} />
      </Container>
      <TrackerButton
        buttonName={ButtonName.CloseIdleTimeModal}
        onClick={activate}
        fullWidth
      >
        {IDLE_TIME_MODAL_TEXTS.BUTTON_TEXT}
      </TrackerButton>
    </>
  );
};
